import { BRIEF_BUILDER as BRIEF_BUILDER_URL, isActiveLocale } from '../constants'
import titleCase from './textTransformation/titleCase'

const buildLocationString = ({
  location,
  countryCode,
  city
}: {
  location?: string
  countryCode?: string
  city?: string
}) => {
  if (location && countryCode && city) {
    // casing not guaranteed to survive HTTP but worth a shot
    return `${titleCase(location)}, ${titleCase(city)}, ${countryCode.toUpperCase()}`
  }

  return ''
}

type CtaUrlProps = {
  collectionId?: string
  locale: string
  location?: string
  countryCode?: string
  city?: string
}

const getCallToActionUrl = ({ collectionId, locale, ...locationParams }: CtaUrlProps) => {
  if (!isActiveLocale(locale)) {
    // SOFT_LAUNCH_URLS is empty
    // return SOFT_LAUNCH_URLS[locale]
    return ''
  }
  const eventTypeQuery = collectionId ? `collection-id=${encodeURIComponent(collectionId)}` : ''
  const locationStr = buildLocationString(locationParams)
  const locationQuery = locationStr && `location=${encodeURIComponent(locationStr)}`
  const query = [eventTypeQuery, locationQuery].filter((q) => q !== '').join('&')

  return `${BRIEF_BUILDER_URL}${query === '' ? '' : `?${query}`}`
}

export default getCallToActionUrl
